import {v4 as uuidv4} from 'uuid';

export class Video {
  constructor(
    public initiator: string,
    public id: string = uuidv4(),
    public title: string = '',
    public desc = '',
    public videoChannel = '',
    public previewImage = '',
    public videoUrl = '',
  ) {
  }
}
